import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    bg: 'white',
    border: '1px',
    borderColor: 'gray.300',
    borderRadius: 'md',
    p: 4,
  },
});
